import React, { useEffect }  from "react";
import classes from "../../style/Style.module.css";
import { useLocation, useNavigate } from "react-router-dom";
import LottieAnimation2 from "../../Components/Animation/LottieAnimation2";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { ROUTE_BANK_MSG_SCREEN } from "../../Routes";

const DextersScanning2 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { BankVerificationMsg } = location.state || {};

  const HandleBack = () => {
    navigate("/dexterr-bank-name");;
  };
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      navigate(ROUTE_BANK_MSG_SCREEN, {
        state: {
          BankMessage : BankVerificationMsg,
        },
      }); 
    }, 5000);

    return () => clearTimeout(timeoutId);
  }, [navigate]);

  return (
    <div className={classes.DextersScanning_Main_Container2}>
      <div className={classes.Header}>
        <ArrowBackIosIcon className={classes.Back_btn} onClick={HandleBack} />
        

        {/* <div className={classes.Dexter_Explainer_Container}>
        <img alt="" src={DexterCall} />
          <span className={classes.Dexter_Call_text}>Dexterr Explains</span>
        </div> */}
      </div>

      <div className={classes.LottiePlayer_Container2}>
        <LottieAnimation2 />
      </div>
      <div className={classes.Dexteranimation2_text}>
        Depositing ₹1 to your Bank Account
      </div>
    </div>
  );
};

export default DextersScanning2;
